import { TextField } from "@mui/material";
import { makeStyles } from "@mui/styles";
import type { ChangeEvent } from "react";
import { useTranslation } from "react-i18next";
import { Icon } from "~/common/components/icon/Icon";
import { IconType } from "~/common/components/icon/IconType";
import { MEDIA_QUERY_MIN_DESKTOP_M, MEDIA_QUERY_MIN_DESKTOP_S, MEDIA_QUERY_MIN_TABLET } from "~/utils/screenSizes";

interface AccountSelectionSearchProps {
  value: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  className?: string;
}

const useStyles = makeStyles({
  textInput: {
    padding: "0 40px",
    minWidth: "auto",
    width: "100%",
    [`@media ${MEDIA_QUERY_MIN_TABLET}`]: {
      width: "60%",
    },
    [`@media ${MEDIA_QUERY_MIN_DESKTOP_S}`]: {
      width: "40%",
    },
    [`@media ${MEDIA_QUERY_MIN_DESKTOP_M}`]: {
      width: "25%",
    },
  },
  searchIcon: {
    marginRight: "8px",
  },
});

const AccountSelectionSearch = ({ value, onChange, className }: AccountSelectionSearchProps) => {
  const { t } = useTranslation();
  const styles = useStyles();
  return (
    <TextField
      classes={{ root: styles.textInput }}
      className="mb-3"
      variant="outlined"
      label={t("accountSelection.search.label")}
      value={value}
      onChange={onChange}
      placeholder={t("accountSelection.search.helperText")}
      InputProps={{ startAdornment: <Icon className={styles.searchIcon} type={IconType.Search} /> }}
    />
  );
};

export default AccountSelectionSearch;
